import React, { useState, useEffect, useCallback, useLayoutEffect, useRef } from 'react';
import BeatItem from './BeatItem';
import styles from './BeatList.module.css';
import axios from 'axios';

const BeatList = ({ userId, restartAutoScroll, propBeats, isAuthenticated, highlightedBeatId, sendEvent, searchQuery = '' }) => {
  const [beats, setBeats] = useState([]);
  const [currentlyPlaying, setCurrentlyPlaying] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const firstLoad = useRef(true);

  useEffect(() => {
    const fetchBeats = async () => {
      try {
        if (propBeats) {
          setBeats(propBeats);
        } else {
          const response = await axios.get('/api/beats');
          setBeats(response.data);
        }
        setIsLoading(false);
	if (firstLoad.current && restartAutoScroll) {
	  restartAutoScroll();
	  firstLoad.current = false;
	}
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchBeats();
  }, [propBeats, restartAutoScroll]);

  useLayoutEffect(() => {
    if (highlightedBeatId && beats.length > 0) {
      const highlightedElement = document.getElementById(`beat-${highlightedBeatId}`);
      if (highlightedElement) {
        highlightedElement.scrollIntoView({ behavior: 'auto', block: 'center' });
      }
    }
  }, [highlightedBeatId, beats]);

  const handlePlay = useCallback((id) => {
  setCurrentlyPlaying((prev) => (prev === id ? null : id));
  }, []);

  const handleTagClick = (tag) => {
    setSelectedTags((prevTags) => {
      if (prevTags.includes(tag)) {
        return prevTags.filter((t) => t !== tag);
      } else {
        return [...prevTags, tag];
      }
    });
  };

  const filteredBeats = selectedTags.length > 0
    ? beats.filter((beat) => selectedTags.every((tag) => beat.moodTags.includes(tag) || beat.artistSticker === tag))
    : beats;

  const searchBeats =
    searchQuery.trim() === ''
      ? filteredBeats
      : filteredBeats.filter((beat) =>
          [
            beat.title,
            beat.genre,
            beat.artistSticker,
	    String(beat.bpm),
            beat.keySignature,
            ...beat.moodTags
          ]
            .join(' ')
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        );

  return (
    <div
      className={`${styles.beatList} ${!isLoading ? styles.visible : ''}`}
    >
      {isLoading ? (
        <div className={styles.listSpinnerContainer}>
          <div className={styles.listSpinner}></div>
        </div>
      ) : (
        searchBeats.map((beat) => (
          <BeatItem
            key={beat.id}
            id={beat.id}
            coverImage={beat.coverImage}
            title={beat.title}
            genre={beat.genre}
            bpm={beat.bpm}
            keySignature={beat.keySignature}
            moodTags={beat.moodTags}
            priceWav={beat.priceWav}
            priceKit={beat.priceKit}
            isPlaying={currentlyPlaying === beat.id}
            onPlay={() => handlePlay(beat.id)}
            onTagClick={handleTagClick}
            selectedTags={selectedTags}
            isAuthenticated={isAuthenticated}
            highlighted={beat.id === highlightedBeatId}
            sendEvent={sendEvent}
	    artistSticker={beat.artistSticker}
          />
        ))
      )}
    </div>
  );
};

export default BeatList;


